var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotificationBellFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M14 18.341c0 .9-.916 1.66-2 1.66s-2-.76-2-1.66v-.34h4v.34zm6.52-3.134l-1.8-1.803V8.936c0-3.48-2.502-6.437-5.821-6.877-1.921-.255-3.861.331-5.316 1.607C6.119 4.948 5.28 6.793 5.28 8.727l-.001 4.677-1.8 1.804c-.47.47-.608 1.17-.354 1.782.255.613.848 1.01 1.512 1.01H8v.341c0 2.018 1.794 3.66 4 3.66s4-1.642 4-3.66v-.34h3.362c.664 0 1.257-.397 1.51-1.01.256-.614.117-1.314-.351-1.784z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationBellFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification_bell_filled.d553cca6.svg";
export { ForwardRef as ReactComponent };